import React, { useEffect, useState, useMemo, memo } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import PreLoader from "../components/helpersUI/loading/PreLoader.jsx";
import { urlServer } from "../helpers/urlCompany";
import {
  setCompanyLoadedToRedux,
  setFooterLoadedToRedux,
  setCompanyPermissionsRoutes,
  setCompanyPermissionsIntegrations,
  setCompanyTagsManager,
  setCompanyResources,
} from "../actions/company.js";
import NotFound from "../components/helpersUI/NotFound.jsx";
import { FirebaseProvider } from "../firebase/FirebaseContext.js";
import CompanyProvider from "./CompanyProvider.jsx";

const Company = memo(({ match }) => {
  const dispatch = useDispatch();
  const { params } = match;

  const [configData, setConfigData] = useState({
    companyConfig: null,
    companyLoaded: false,
    checking: true,
    errorConfig: false,
    msgError: "",
  });

  useEffect(() => {
    const companyName = params.company.replace("/", "");
    const companyToSearch = companyName.toLowerCase();

    axios
      .post(`${urlServer}/company`, {
        company: companyToSearch,
      })
      .then((response) => {
        const {
          status,
          message,
          permissionsRoutes,
          permissionsIntegrations,
          dbConnection,
          urlServer,
          urlWeb,
          footerDocuments,
          tagsManager,
          resources,
        } = response.data;

        if (status === 200) {
          dispatch(setCompanyLoadedToRedux(companyName));
          dispatch(setFooterLoadedToRedux(footerDocuments));
          dispatch(setCompanyPermissionsRoutes(permissionsRoutes));
          dispatch(setCompanyPermissionsIntegrations(permissionsIntegrations));
          dispatch(setCompanyTagsManager(tagsManager));
          dispatch(setCompanyResources(resources));

          setConfigData({
            companyConfig: {
              dbConnection,
              urlServer,
              urlWeb,
              companyName,
              footerDocuments,
              tagsManager,
              resources,
            },
            companyLoaded: true,
            checking: false,
            errorConfig: false,
            msgError: "",
          });
        } else {
          setConfigData((prevState) => ({
            ...prevState,
            checking: false,
            msgError: message,
            errorConfig: true,
          }));
        }
      })
      .catch((error) => {
        console.log("ERROR Axios", error);

        setConfigData((prevState) => ({
          ...prevState,
          checking: false,
          msgError: "Error al cargar la organización",
          errorConfig: true,
        }));
      });
  }, [params]);

  const renderError = useMemo(() => {
    if (configData.errorConfig) {
      return (
        <div className="flex items-center justify-center min-h-screen text-center bg-gradient-to-r from-saluta-s to-saluta-c">
          <NotFound msg={configData.msgError} />
        </div>
      );
    }
    return null;
  }, [configData.errorConfig, configData.msgError]);

  const renderLoading = useMemo(() => {
    if (configData.checking) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-r from-saluta-s to-saluta-c">
          <PreLoader
            text={"Cargando"}
            classText="text-white font-bold z-100"
            opacity={50}
            isLoading={configData.checking}
          />
        </div>
      );
    }
    return null;
  }, [configData.checking]);

  return (
    <>
      {renderError}
      {renderLoading}
      {configData.companyLoaded && !configData.errorConfig && (
        <FirebaseProvider
          company={configData.companyConfig}
          setConfigData={setConfigData}
        >
          <CompanyProvider companyName={configData.companyConfig.companyName} />
        </FirebaseProvider>
      )}
    </>
  );
});

export default Company;
